export const PHLEBOTOMY_SUPPORT_EMAIL = "support@billiontoone.com";
export const PHLEBOTOMY_SUPPORT_PHONE = "+16504602551";
export const PHLEBOTOMY_SUPPORT_PHONE_DISPLAY = "+1 (650) 460-2551";
